import { TicketDetails } from './TicketDetails';
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { useAutoAnimate } from '@formkit/auto-animate/react';

export const TicketConversations = ({ ticketId, userId, conversations, classes, userEmail }) => {
  const ticketConversations = conversations?.find(conversation => conversation.ticketId === ticketId)?.data || [];
  const [animation] = useAutoAnimate();
  
  return (
    <div ref={animation} className={classes.commentWrapper}>
      {ticketConversations.map(({ id, user_id, to_emails, created_at, body }, index) => (
        <div key={id || index} className={classes.commentContent}>
          <TicketDetails name={user_id === userId ? userEmail : 'ES Kassasystem'}
                         timestamp={created_at}
                         isUser={user_id === userId}
                         classes={classes}
          />
          <div className={classNames(classes.ticketResponse, 'view ql-editor')}
               dangerouslySetInnerHTML={{ __html: body }} />
        </div>
      ))}
    </div>
  );
};

TicketConversations.propTypes = {
  ticketId: PropTypes.number,
  userId: PropTypes.number,
  conversations: PropTypes.array,
  classes: PropTypes.object,
  userEmail: PropTypes.string,
};